<template>
  <div class="d-activity-entry-social">
    <div class="actions grid-2 grid-no-response">
      <div class="grid-item">
        <span class="action-entry">
          <button
            class="upvote-button button-sm button-follow"
            :class="{ 'button-yellow': activity.is_upvoted }"
            :disabled="isProcessing"
            title="Like"
            @click="upvote"
          >
            <DuiIconLike
              v-if="activity.is_upvoted"
              class="icon-white"
            />

            <DuiIconLikeStroke v-else />

            <span class="num-upvotes valign-middle">{{ activity.upvotes }}</span>
          </button>

          <a
            v-if="!!activity.upvotes"
            class="view-upvotes valign-middle"
            @click="showUpvotes"
          >View likes</a>
        </span>
      </div>
      <div class="grid-item text-right">
        <span class="action-entry">
          <DuiIconBalloonStroke />
          <span class="num-comments valign-middle">{{ numComments }}</span>
        </span>

        <button
          v-if="!activity.is_owner"
          class="repost-button button-sm button-follow"
          @click="repost"
        >
          <span class="valign-middle">Repost</span>
          <DuiIconRepost
            class="repost-icon icon-sm2"
            style="margin: -4px 0;"
          />
        </button>
      </div>
    </div>

    <DActivityRepostModal
      v-if="isRepostingActivity"
      :activity="isRepostingActivity"
      @dismiss="dismissActivityRepost"
      @post-created="postCreated"
    />

    <DUpvotesModal
      v-if="isUpvotesDisplayed"
      item-type="post"
      :item-slug="activity.slug"
      :is-user-signed-in="isUserSignedIn"
      @dismiss="dismissUpvotes"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import DUpvotesModal from '@d-components/modals/d-upvotes-modal/d-upvotes-modal.vue';
import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import { getErrorMessage } from '@d-shared/utils/errors';

import DActivityRepostModal from './d-activity-repost-modal/d-activity-repost-modal.vue';

export default {
  components: {
    DActivityRepostModal,
    DUpvotesModal,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
    numComments: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    isProcessing: false,
    isRepostingActivity: null,
    isUpvotesDisplayed: false,
  }),
  methods: {
    // Repost
    dismissActivityRepost() {
      this.$set(this, 'isRepostingActivity', null);
    },

    postCreated(newPost) {
      this.$emit('post-created', newPost);
    },

    repost() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }

      this.$set(this, 'isRepostingActivity', this.activity);
    },
    // END Repost

    // Upvote
    async addUpvote() {
      this.$set(this, 'isProcessing', true);

      try {
        await activityFeedService.addPostUpvote(this.activity.slug);
        this.$set(this.activity, 'is_upvoted', true);
        this.$set(this.activity, 'upvotes', this.activity.upvotes + 1);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    async removeUpvote() {
      this.$set(this, 'isProcessing', true);

      try {
        await activityFeedService.removePostUpvote(this.activity.slug);
        this.$set(this.activity, 'is_upvoted', false);
        this.$set(this.activity, 'upvotes', this.activity.upvotes - 1);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    upvote() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }

      if (this.activity.is_upvoted) {
        this.removeUpvote();
        return;
      }

      this.addUpvote();
    },
    // END Upvote

    // Upvotes
    dismissUpvotes() {
      this.$set(this, 'isUpvotesDisplayed', false);
    },

    showUpvotes() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }

      this.$set(this, 'isUpvotesDisplayed', true);
    },
    // END Upvotes
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-activity-entry-social {
  .actions .action-entry {
    font-size: $font-size-sm;
    font-weight: $base-weight-bold;
    margin-right: $_1em;

    .upvote-button {
      margin-right: $_0-5em;
    }

    .action-label {
      margin-left: -$_0-5em;
    }

    a {
      color: getColor($black);
    }
  }
}
</style>
